import React from "react";

import { Grid, Typography } from "@mui/material";

import CompaniesLogos from "../images/top_companies.svg";

import {
  TrustedByContainer,
  TrustedByGridItem,
  TrustedByGridContainer,
} from "./styles";

const TrustedBy = () => {
  return (
    <TrustedByContainer>
      <TrustedByGridContainer container spacing={3}>
        <TrustedByGridItem item md={4}>
          <Typography variant="h2" color="common.white">
            Trusted By
          </Typography>
          <Typography variant="h2neon">Top Companies</Typography>
        </TrustedByGridItem>
        <Grid item md={8} sx={{ maxWidth: "100vw" }}>
          <img
            src={CompaniesLogos}
            alt="top companies logos"
            style={{ width: "100%" }}
          />
        </Grid>
      </TrustedByGridContainer>
    </TrustedByContainer>
  );
};

export default TrustedBy;
